export default __webpack_public_path__ + "static/media/card2-crop.9b392e0e.jpg";